import React from 'react';
const RightArrow = ({color = "white"}) => {
    return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 4.16675L13.3333 10.0001L7.5 15.8334" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    )
}

export {RightArrow};